var api = "https://api.qingcigame.com/jpweb";
var index = '';
var is_jp_email = '';
var invited_code = '';
var faqListChange = true;
var register_switch = false;
var _index = $('.index');
var obj = {
    index: function() {
        this.preloading(); // 预加载
        this.onAdaptive();
        this.indexAjax(); // 首页数据
        this.indexBind(); // 首页按钮
        this.clipboard(); // 复制
        this.hiddenNav();
        this.bookcaseBind(); // 书柜辞典模块
    },
    // 新闻列表
    newsList: function() {
        this.pageShow();
        var urls = api + "/article"; // 第一页
        this.hiddenNav(); // 头部隐藏导航
        this.newsZxList(urls); // 新闻最新列表
        this.newsTabPage(); // 新闻导航切换
    },
    // 游戏攻略列表
    intrList: function() {
        var urls = api + "/article"; // 第一页
        this.hiddenNav(); // 头部隐藏导航
        this.newsIntrList(urls); // 新闻最新列表
        this.newsTabPage(); // 新闻导航切换
    },
    // 新闻详情
    newsDetails: function() {
        this.pageShow();
        this.hiddenNav(); // 头部隐藏导航
        this.newsInfo(); // 新闻详情
    },
    // 视频中心
    videoCenter: function() {
        this.pageShow();
        this.hiddenNav(); // 头部隐藏导航
        this.videoSwitch(); // 新闻导航切换
        this.videoCenterAjax(); // 获取视频中心视频
    },
    // 视频详情
    videoDetails: function() {
        this.hiddenNav(); // 头部隐藏导航
        this.videoDetailsAjax(); // 获取详细的视频
    },
    // wiki首页
    wikiIndex: function() {
        this.hiddenNav(); // 头部隐藏导航
        this.wikiIndexAjax();
    },
    // 漫画续集
    comicSequel: function() {
        this.pageShow();
        this.hiddenNav(); // 头部隐藏导航
        this.comicSequelAjax(); // 获取漫画续集
    },
    // wiki-贵重物品
    wikiPrecious: function() {
        var rarity, deviation, deviation, mosaic_skill, halo_effect, column, order, page, url;
        this.getWikiData(); // 获取筛选的参数
        this.wikibind(); // wiki绑定事件 
        this.filtering(); // wiki-贵重物品-筛选
        this.wikiearch(); // wiki-贵重物品-搜索
        this.wikiTabInfo(); // tab切换信息
        this.wikiPopup(); // 弹窗的开关查看详情
        this.preventInput(); // 阻止页面弹起
        this.hiddenNav(); // 头部隐藏导航
    },
    contactIndex: function() {
        this.pageShow();
        this.contactBind();
        this.hiddenNav(); // 头部隐藏导航
    },
    feedbackIndex: function() {
        this.pageShow();
        this.feedbackBind();
        this.hiddenNav(); // 头部隐藏导航
    },
    faqIndex: function() {
        this.pageShow();
        this.faqBind();
        this.hiddenNav(); // 头部隐藏导航
        this.faqListAjax(1);
    },
    contactBind: function() {

        var wj_url = [];
        var name_url = [];

        // 开关协议按钮
        $('.checked').on('click', function(event) {
            $(this).hasClass('on') ? $(this).removeClass('on') : $(this).addClass('on')
        });

        // 更新图片地址
        $("#upload").on("change", "input[type='file']", function() {
            var filePath = $(this).val();
            var arr = filePath.split('\\');
            var fileName = arr[arr.length - 1];
            $(".file-info").html(fileName);
            $('.file-list').find('li').length + 1 >= 10 ? $("#upload").hide() : $("#upload").show();

            if ($('.file-info').html() !== '選択されていません') {
                $(".file-info").html('選択されていません');
                var index = layer.load(2, { shade: [0.1, '#fff'] });
                var form = document.getElementById('upload'),
                    formData = new FormData(form);
                $.ajax({
                    url: "https://api.qingcigame.com/jpweb/upload",
                    type: "post",
                    data: formData,
                    processData: false,
                    contentType: false,
                    success: function(res) {
                        if (res.code == 200) {
                            var addFileHtml = '<li>' +
                                '<a href="javascript:;" data="' + res.data.oss_url + '">キャンセル</a>' +
                                '<span class="file-name">' + fileName + '</span>' +
                                '</li>';
                            $('.file-list ul').append(addFileHtml);
                            name_url.push(fileName);
                            wj_url.push(res.data.oss_url)
                            layer.close(index);
                        } else {
                            layer.msg('アップロードするファイルは10 MBを超えてはいけません', { time: 2000 });
                            layer.close(index);
                        }
                    },
                    error: function(err) {
                        layer.close(index);
                        layer.msg("アップロードするファイルは10 MBを超えてはいけません", err);
                    }
                })
            }
        })

        $('.file-list').on('click', 'li a', function(event) {
            var index = layer.load(2, { shade: [0.1, '#fff'] });
            setTimeout(() => {
                layer.close(index);
                var is_data = $(this).attr('data');
                var is_name = $(this).siblings('span').html();
                wj_url = wj_url.filter((item, index, array) => item != is_data);
                name_url = name_url.filter((item, index, array) => item != is_name);
                console.log(name_url);
                $(this).parents('li').remove();
                console.log($('.file-list').find('li').length)
                $('.file-list').find('li').length >= 10 ? $("#upload").hide() : $("#upload").show();
            }, 500);
        });

        $("textarea[name=contact_detail]").keyup(
            function() {
                var count = $(this).val().length;
                $('.font-length').html('(' + count + '/400)');
            }
        );


        $('.verification-btn').on('click', function(event) {
            var trainer_id = $("input[name=trainer_id]").val(); // 角色id
            var u_id = $("input[name=u_id]").val(); // uid
            var app_ver = $("input[name=app_ver]").val(); // 版本号
            var os_ver = $("input[name=os_ver]").val(); // 服务环境
            var device_name = $("input[name=device_name]").val(); // 设备端
            var contact_kind = $(".js-select[name=contact_kind] option:selected").val(); // 问题类型
            var file = $("input[name=file]").val(); // 添加文件
            var device_type = $(".js-select[name=device_type] option:selected").val(); // 环境类型
            var trainer_name = $("input[name=trainer_name]").val(); // 游戏中角色名称
            var issue_date = $("input[name=issue_date]").val(); // 问题时间
            var issue_hour = $(".js-select[name=issue_hour] option:selected").val(); // 时
            var issue_minute = $(".js-select[name=issue_minute] option:selected").val(); // 分
            var issue_point = $("input[name=issue_point]").val(); // 发生问题处
            var contact_detail = $("textarea[name=contact_detail]").val(); // 详细描述
            var mailaddress = $("input[name=mailaddress]").val(); // 邮箱
            var checkbox = $("input[type=checkbox").attr("checked"); // 协议是否开启
            var not_entered = '未入力';
            var verification = /([a-z0-9]*[a-z0-9]+)*@([a-z0-9]*[-_]?[a-z0-9]+)+[.][a-z]{2,3}([.][a-z]{2})?/i;

            console.log('输入的文案长度', contact_detail.length)
            if (contact_detail.length > 400) {
                layer.msg("文字数の上限を超えました。ご調整ください。", { time: 2000 });
                return
            }
            var index = layer.load(2, { shade: [0.1, '#fff'] });
            $('.center-main').fadeOut();
            $(document).scrollTop(0);
            setTimeout(function() {
                layer.close(index);
                $('.center-main').fadeIn();

                function typePd(judge, class1, class2) {
                    if (judge) {
                        $(class1).show();
                        $(class2).addClass('error')
                    } else {
                        $(class1).hide();
                        $(class2).removeClass('error')
                    }
                }
                var must0 = typePd(u_id == '', '.type-0', 'input[name=u_id]');
                var must1 = typePd(contact_kind == 0, '.type-1', '.js-select[name=contact_kind]');
                var must2 = typePd(device_type == 0, '.type-2', '.js-select[name=device_type]');
                var must3 = typePd(contact_detail == '', '.type-3', 'textarea[name=contact_detail]');
                var must4 = typePd(mailaddress == '', '.type-4', 'input[name=mailaddress]');
                var must5 = typePd(!verification.test(mailaddress), '.type-4', 'input[name=mailaddress]');
                var must6 = typePd(!$('.checked').hasClass('on'), '.type-5', 'input[type=checkbox]');

                var all_meet = u_id !== '' && contact_kind !== '0' && device_type !== '0' && contact_detail !== '' && mailaddress !== '' && $('.checked').hasClass('on') && verification.test(mailaddress);
                if (all_meet) {
                    $('#error-area').hide();
                    $('.center-main').hide();
                    $('.center-main-confirm').show();

                    trainer_id == '' ? $('.trainer_id').html(not_entered) : $('.trainer_id').html(trainer_id);
                    u_id == '' ? $('.u_id').html(not_entered) : $('.u_id').html(u_id);
                    file == '' ? $('.file').html(not_entered) : $('.file').html(name_url.toString());
                    app_ver == '' ? $('.app_ver').html(not_entered) : $('.app_ver').html(app_ver);
                    os_ver == '' ? $('.os_ver').html(not_entered) : $('.os_ver').html(os_ver);
                    device_name == '' ? $('.device_name').html(not_entered) : $('.device_name').html(device_name);
                    contact_kind == '' ? $('.contact_kind').html(not_entered) : $('.contact_kind').html(contact_kind);
                    device_type == '' ? $('.device_type').html(not_entered) : $('.device_type').html(device_type);
                    trainer_name == '' ? $('.trainer_name').html(not_entered) : $('.trainer_name').html(trainer_name);
                    issue_date == '' ? $('.issue_date').html(not_entered) : $('.issue_date').html(issue_date + issue_hour + issue_minute);
                    // issue_point     == '' ? $('.issue_point').html(not_entered)     : $('.issue_point').html(issue_point);
                    contact_detail == '' ? $('.contact_detail').html(not_entered) : $('.contact_detail').html(contact_detail);
                    mailaddress == '' ? $('.mailaddress').html(not_entered) : $('.mailaddress').html(mailaddress);

                    $('#error-area').hide();
                    $('.center-main').hide();
                    $('.center-main-confirm').show();
                    layer.close(index);

                    return
                }
                $('#error-area').show();
            }, 1000)
        });

        // 返回上一页
        $('.return-btn').click(function(event) {
            var index = layer.load(2, { shade: [0.1, '#fff'] });
            setTimeout(function() {
                layer.close(index);
                $(document).scrollTop(0);
                $('.center-main').show();
                $('.center-main-confirm, .feedback-results').hide();
            }, 1000)
        });

        $('.send-btn').click(function(event) {
            var trainer_id = $("input[name=trainer_id]").val(); // 角色id 
            var u_id = $("input[name=u_id]").val(); // uid             
            var app_ver = $("input[name=app_ver]").val(); // 版本号
            var os_ver = $("input[name=os_ver]").val(); // 服务环境
            var device_name = $("input[name=device_name]").val(); // 设备端
            var contact_kind = $(".js-select[name=contact_kind] option:selected").val(); // 问题类型
            var device_type = $(".js-select[name=device_type] option:selected").val(); // 环境类型
            var trainer_name = $("input[name=trainer_name]").val(); // 游戏中角色名称
            var issue_date = $("input[name=issue_date]").val(); // 问题时间
            var issue_hour = $(".js-select[name=issue_hour] option:selected").val(); // 时
            var issue_minute = $(".js-select[name=issue_minute] option:selected").val(); // 分
            var issue_point = $("input[name=issue_point]").val(); // 发生问题处
            var contact_detail = $("textarea[name=contact_detail]").val(); // 详细描述
            var mailaddress = $("input[name=mailaddress]").val(); // 邮箱
            var checkbox = $("input[type=checkbox").attr("checked"); // 协议是否开启

            var index = layer.load(2, { shade: [0.1, '#fff'] });
            $.ajax({
                url: api + "/consule/upload",
                type: "POST",
                data: {
                    user_id: trainer_id, // 用户id
                    u_id: u_id, // 用户id
                    version: app_ver, // 应用版本
                    systems: os_ver, // 操作系统版本
                    equipment_name: device_name, // 设备名称
                    content_type: contact_kind, // 咨询内容类型
                    game_nickname: trainer_name, // 游戏昵称
                    use_environment: device_type, // 使用环境
                    time: issue_date + '-' + issue_hour + '-' + issue_minute, // 问题的日期和时间
                    problem: issue_point, // 出现问题的地方
                    dateiled_content: contact_detail, // 咨询内容
                    user_email: mailaddress, // 电子邮件地址
                    video_url: 0,
                    url: wj_url.toString() // 文件地址

                },
                xhrFields: {
                    withCredentials: true
                },
                success: function(json) {
                    if (json.code == 200) {
                        layer.close(index);
                        $(document).scrollTop(0);
                        $('.center-main-confirm').hide();
                        $('.feedback-results').fadeIn();
                        $('.results').html(json.message);
                    } else {
                        layer.msg(json.message, { time: 2000 });
                    }
                },
                error: function() {
                    layer.msg("サーバーに接続できません", { time: 2000 });
                },
                complete: function() {
                    layer.close(index);
                }
            })
        });


        $('#input-date').datetimepicker({
            onGenerate: function(ct) {},
            timepicker: false,
            format: 'Y-m-d',
            lang: 'ja'
        });
    },
    feedbackBind: function() {
        $('.feedback-btn').on('click', function(event) {

            var contact_detail = $("textarea[name=contact_detail]").val(); // 详细描述
            $('.center-main').fadeOut();

            var index = layer.load(2, { shade: [0.1, '#fff'] });
            $(document).scrollTop(0);
            setTimeout(function() {
                layer.close(index);
                $('.center-main').fadeIn();

                function typePd(judge, class1, class2) {
                    if (judge) {
                        $(class1).show();
                        $(class2).addClass('error')
                    } else {
                        $(class1).hide();
                        $(class2).removeClass('error')
                    }
                }
                var must3 = typePd(contact_detail.length < 6, '.type-1', 'textarea[name=contact_detail]');

                var all_meet = contact_detail.length >= 6;
                if (all_meet) {
                    $('#error-area').hide();
                    $('.center-main').hide();
                    $('.center-main-confirm').show();

                    contact_detail == '' ? $('.contact_detail').html(not_entered) : $('.contact_detail').html(contact_detail);
                    return
                }
                $('#error-area').show();
            }, 1000)
        });

        // 返回上一页
        $('.return-btn').click(function(event) {
            var index = layer.load(2, { shade: [0.1, '#fff'] });
            setTimeout(function() {
                layer.close(index);
                $(document).scrollTop(0);
                $('.center-main').show();
                $('.center-main-confirm, .feedback-results').hide();
            }, 1000)
        });

        var changeS = true;
        $('.mail-sending-btn').click(function(event) {
            var contact_detail = $('.contact_detail').html();
            if (changeS) {
                changeS = false;
                var index = layer.load(2, { shade: [0.1, '#fff'] });
                $(document).scrollTop(0);
                $.ajax({
                    url: api + "/consule/opinion",
                    type: "POST",
                    data: {
                        dateiled_content: contact_detail
                    },
                    xhrFields: {
                        withCredentials: true
                    },
                    success: function(json) {
                        if (json.code == 200) {
                            setTimeout(() => {
                                layer.close(index);
                                changeS = true;
                                $('.feedback-main-confirm').hide();
                                $('.feedback-results').fadeIn();
                                $('.results').html(json.message);
                            }, 2000);
                        }
                    },
                    error: function() {
                        layer.msg("サーバーに接続できません", { time: 2000 });
                    },
                    complete: function() {

                    }
                })
            }
        });
    },
    // faq页面

    faqBind: function() {
        var id = 1;
        $('.faq-tab-title').on('click', 'li', function(event) {
            obj.faqListAjax($(this).attr('id'));
            $(this).addClass('on').siblings().removeClass('on');
            faqListChange = false;
        });

        $('.faq-list').on('click', 'a', function(event) {
            if ($(this).parent('li').hasClass('li-show')) {
                $(this).parent('li').removeClass('li-show');
            } else {
                $(this).parent('li').addClass('li-show');
            }
        });

        $('.search-btn').on('click', function(event) {
            var searchIpu = $('.search-input').val()
            if (searchIpu == '') {
                $('.faq-tab-title a').show();
                $('.faq-result').find('.result-num').html('0');
                obj.faqListAjax(1);
                return
            }
            var index = layer.load(2, { shade: [0.1, '#fff'] });
            $.ajax({
                url: api + "/consule/faq",
                type: "GET",
                data: {
                    title: searchIpu
                },
                xhrFields: {
                    withCredentials: true
                },
                success: function(json) {
                    if (json.code == 200) {
                        $('.faq-tab-title a').hide();
                        $('.new-list ul li').remove();
                        // 渲染列表
                        $.each(json.data, function(index, values) {
                            var dtHtml = '<li>' +
                                '<a href="javascript:;">' +
                                '<i></i><em></em>' +
                                '<p class="lside">' +
                                '<span class="comment">' + values.title + '</span>' +
                                '</p>' +
                                '</a>' +
                                '<div class="hide-info">' + values.content + '</div>' +
                                '</li>';
                            $('.new-list ul').append(dtHtml);
                            $('.new-list').addClass('new-list-show');
                        });
                        $('.faq-result').find('.result-num').html($('.new-list ul li').length);
                    }
                },
                error: function() {
                    layer.msg("サーバーに接続できません", { time: 2000 });
                },
                complete: function() {
                    layer.close(index);
                }
            })
        });
    },
    // faq列表
    faqListAjax: function(id) {
        var index = layer.load(2, { shade: [0.1, '#fff'] });
        $.ajax({
            url: api + "/consule/faq",
            type: "GET",
            data: {
                tag_id: id
            },
            xhrFields: {
                withCredentials: true
            },
            success: function(json) {
                if (json.code == 200) {
                    $('.new-list ul li').remove();
                    // 标题渲染
                    if (faqListChange == true) {
                        $.each(json.data.tag, function(index, values) {
                            var titleHtml = '<li class="li-' + values.id + '" id="' + values.id + '">' +
                                '<a href="javascript:;">' + values.faq_tag + '</a>' +
                                '</li>';
                            $('.faq-tab-title').append(titleHtml);
                        });
                    }

                    // 渲染列表
                    $.each(json.data.commonProbelm, function(index, values) {
                        var dtHtml = '<li>' +
                            '<a href="javascript:;">' +
                            '<i></i><em></em>' +
                            '<p class="lside">' +
                            '<span class="comment">' + values.title + '</span>' +
                            '</p>' +
                            '</a>' +
                            '<div class="hide-info">' + values.content + '</div>' +
                            '</li>';
                        $('.new-list ul').append(dtHtml);
                        $('.new-list').addClass('new-list-show');
                    });
                } else {
                    layer.msg("サーバーに接続できません", { time: 2000 });
                }

            },
            error: function() {
                layer.msg("サーバーに接続できません", { time: 2000 });
            },
            complete: function() {
                layer.close(index);
            }
        })

    },
    // 首页提示
    indexBind: function() {
        $('.monitor-btn').on('click', function() {
            var mon_btn = $(this).attr('data-event');
            obj.countNum(mon_btn);
        });

        // 规则弹窗
        $('.rule-btn').click(function(event) {
            $('.rule-wrap').fadeIn();
        });

        // 点击邮箱按钮开启弹窗
        $('.mailbox-btn').click(function(event) {
            if (register_switch == true) {
                $('.success-wrap').fadeIn();
                return
            }
            $('.mailbox-wrap').fadeIn();
        });

        // 查看奖励列表
        $('.reward-btn').click(function(event) {
            $('.invitation-award-wrap').fadeIn();
        });

        // 开启邀请奖励弹窗
        $('.invitation-btn').click(function(event) {
            $('.popup').fadeOut();
            $('.invitation-award-wrap').fadeIn();
        });

        // 预约入口 && 邀请奖励入口(->邀请好友)
        $('.invitation-btn-02').click(function(event) {
            $('.popup').fadeOut();
            $('.invitation-wrap').fadeIn();
            // if(is_jp_email == '') {
            //     // 当前没有的登陆过则前往邮箱验证登录
            //     $('.mailbox-wrap').fadeIn();
            // } else {
            //     // 否则前往邀请地址弹窗                
            //     index = layer.load(2, {shade: [0.1, '#fff']});
            //     $.ajax({
            //         url: api + "/reserve/user/url",
            //         type: "POST",
            //         xhrFields: {
            //             withCredentials: true
            //         },
            //         data: {
            //             jp_email: is_jp_email
            //         },
            //         dataType: 'json',
            //         success: function (json) {
            //             if (json.code == 200) {
            //                 $('.invitation-wrap').fadeIn();
            //                 $('#bar').html(window.location.href.split("?")[0] + '?code=' + json.data.code);
            //             } else {
            //                 layer.msg(json.message, {time: 2000});
            //             }
            //         },
            //         complete: function () {
            //             layer.close(index);
            //         }
            //     });
            // }
        });

        // $('.return-btn').click(function (event) {
        //     $('.invitation-award-wrap').fadeIn();
        //     $('.end-invitation-wrap').fadeOut();
        // });

        // 点击邮箱按钮开启弹窗
        $('.det-btn').click(function(event) {
            $('.world-outlook-wrap').fadeIn();
        });

        // 点击隐藏电子邮箱输入
        $('.mailbox-wrap').on('click', '.close-btn', function(event) {
            $('.popup').fadeOut();
        });

        // 请求获取短信验证Ajax
        $('.obtain-verification').on('click', 'a', function() {
            var Email = $('.Email-inp').val();
            if (Email == '') {
                layer.msg("メールを入力してください!", { time: 2000 });
                return
            }
            index = layer.load(2, { shade: [0.1, '#fff'] });
            $.ajax({
                url: api + "/reserve/user/code",
                type: "POST",
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    jp_email: Email
                },
                dataType: 'json',
                success: function(json) {
                    layer.msg(json.message, { time: 2000 });
                    if (json.code == 200) {
                        time();
                    }
                },
                complete: function() {
                    layer.close(index);
                }
            });
        });

        // 600s倒计时
        var wait = 600;

        function time() {
            if (wait == 0) {
                $('.obtain-verification span a').remove();
                $('.obtain-verification span').html("<a class='verify-acquisition-btn'>認証コードを受け取る</a>");
                wait = 600;
            } else {
                $('.obtain-verification span a').remove();
                $('.obtain-verification span').html("<b>" + wait + "s</b>");
                wait--;
                setTimeout(function() {
                    time()
                }, 1000)
            }
        }

        // 预约登录
        $('.appointment-btn').click(function(event) {
            var Email = $('.Email-inp').val();
            var code = $('.code-inp').val();
            if (Email == '') {
                layer.msg("メールを入力してください!", { time: 2000 });
                return
            }
            if (code == '') {
                layer.msg("認証コードを入力してください!", { time: 2000 });
                return
            }
            index = layer.load(2, { shade: [0.1, '#fff'] });
            invited_code = window.location.href.split("?code=")[1];
            setTimeout(() => {
                $.ajax({
                    url: api + "/reserve/user/info",
                    type: "POST",
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        jp_email: Email,
                        code: code,
                        be_invited_code: invited_code,
                    },
                    dataType: 'json',
                    success: function(json) {
                        // 第一次 || 第二次预约操作进入
                        if (json.code == 200 || json.code == 404) {
                            register_switch = true;
                            var _info = json.data.info;
                            var code_one = _info.secret_order_one;
                            var code_two = _info.secret_order_two;
                            var code_three = _info.secret_order_three;
                            is_jp_email = Email; // 将邮箱进行存储
                            var judge1 = judgeChange(code_one, '.type_1');
                            var judge2 = judgeChange(code_two, '.type_3');
                            var judge3 = judgeChange(code_three, '.type_5');

                            $('.popup').fadeOut();
                            $('.success-wrap').fadeIn();

                            $('.success-wrap').removeClass('success-wrap2');
                            if (_info.login_times > 1) {
                                $('.success-wrap').addClass('success-wrap2');
                            }
                        } else {
                            layer.msg(json.message, { time: 2000 });
                        }
                    },
                    complete: function() {
                        layer.close(index);
                    }
                }, 1000);
            });
        });

        function judgeChange(is_Data, is_class) {
            if (is_Data !== '') {
                $(is_class).find('b').html(is_Data);
                $(is_class).find('a').removeClass('wdc');
            }
        }

        $('.li-code').on('click', 'a', function(event) {
            $('.popup').fadeOut();
            $('.invitation-wrap').fadeIn();
            // $(this).hasClass('wdc') ? layer.msg('報酬はまだ達していません!', {time: 2000}) : $(this).fadeOut();
        });

        $('.popup').on('click', '.ok-btn', function(event) {
            $('.popup').fadeOut();
        });


        // 首页第二页游戏介绍信息
        // jQuery(".txtMarquee-top").slide({mainCell:".bd ul",autoPlay:true,effect:"topMarquee",vis:10,interTime:50,mouseOverStop:false});

        $('.recommend-popup').on('click', '.close-btn', function(event) {
            $('.rec-box').addClass('hide-ani');
            $('.recommend-popup').fadeOut();
        });

        $('.swiper-container-video').on('click', '.swiper-slide', function(event) {
            var data = $(this).attr('data');
            $('.popup-wrap').fadeIn().find('iframe').attr('src', data);
        });

        $('.close-btn').click(function(event) {
            $('.popup').fadeOut().find('iframe').attr('src', '');
        });
    },
    // 图片资源预加载
    preloading: function() {
        if (event.persisted || window.performance && window.performance.navigation.type == 2) {
            window.location.reload();
        }
        //图片预加载
        var queue = new createjs.LoadQueue();
        obj.setInterval();
        setTimeout(function() {
            queue.on("progress", function(e) {
                //加载中的进度
                if (e.progress * 100 >= 10) {
                    $(".loding_time span").width(parseInt(e.progress * 100) + '%')
                };
                var numbers = e.progress * 100;
            }, this);
            queue.on("complete", function(e) {
                //加载完成执行操作
                var _this = this;
                $('.loding_time').remove();
                $('.preloading').addClass('preloading-ani').fadeOut(500);
                $('.index').addClass('index-show');
                obj.indexSwiper();
                obj.defaultVideo();
                setTimeout(function() {
                    $('.preloading').remove();
                    obj.twitterShare(); // twitter分享
                }, 1000)
            }, this);
            queue.loadManifest([
                //加载图片，不包括后台的    
                'images/mobile/3rd/index_bg-f11bae9feb.png',
                'images/mobile/m_jdt-0fe07a342f.png',
                'images/mobile/m_dt_t-8682607187.png',
                'images/mobile/m_dt_sz-4bd8caac4f.png',
                'images/mobile/index_content_title-9c5eb40de0.png',
                'images/mobile/index_content_bg_01-54bae98f00.png'
            ]);
        }, 500);
    },
    onAdaptive: function() {
        const width = $(window).width();
        const height = $(window).height();
        const proportion = width / height;
        proportion < 0.568 ? _index.addClass('adaptive-0') : _index.removeClass('adaptive-0');
        proportion >= 0.568 && proportion < 0.606 ? _index.addClass('adaptive-1') : _index.removeClass('adaptive-1');
        proportion >= 0.606 && proportion < 0.650 ? _index.addClass('adaptive-2') : _index.removeClass('adaptive-2');
        proportion >= 0.650 ? _index.addClass('adaptive-3') : _index.removeClass('adaptive-3');
    },
    defaultVideo: function() {
        $(".play-btn").on('click', function() {
            var src = 'https://download4.qcplay.com/file/video_30m.mp4';
            $('.play-btn').fadeIn().attr('data', src);
            $('.popup-wrap').fadeIn().find('iframe').attr('src', $('.play-btn').attr('data')).removeClass('ani-btn');
        })
        $('.popup').on('click', '.close-btn', function(event) {
            $('.popup-wrap').find('iframe').attr('src', '');
        });
    },
    // 首页接口请求
    indexAjax: function() {
        // var index = layer.load(2, {shade: [0.1, '#fff']});
        var _this = this;
        $.ajax({
            // url: "https://tapi.qingcigame.com/jpweb/index",
            url: api + "/index",
            type: "GET",
            xhrFields: {
                withCredentials: true
            },
            success: function(json) {
                if (json.code == 200) {
                    var zonghe = json.data.articleList.zonghe;
                    var activity = json.data.articleList.activity;
                    var cartoon = json.data.articleList.cartoon;
                    var jinjie = json.data.articleList.jinjie;
                    var mengxin = json.data.articleList.mengxin;
                    var video = json.data.articleList.video;
                    var jijie = json.data.articleList.jijie;
                    var ulr = json.data.articleList.ulr;
                    var spec = json.data.articleList.spec;

                    var introduction_index = json.data.articleList.introduction_index;
                    var beginner_guide = json.data.articleList.beginner_guide;
                    var intermediate = json.data.articleList.intermediate;
                    var xingtai = json.data.articleList.xingtai;
                    var explore = json.data.articleList.explore;
                    // url地址
                    $('.app-btn').attr('href', ulr[0].get_url); // App_Store
                    $('.google-btn').attr('href', ulr[1].get_url); // Google_Play
                    $('.amazon-btn').attr('href', ulr[10].get_url); // Amazon

                    $('.twitter-btn, .twitter-share-btn, .hot-activities-btn, .twitter-timeline').attr('href', ulr[2].get_url); // Twitter
                    $('.discord-btn').attr('href', ulr[9].get_url); // Discord
                    $('.open-chat-btn, .line-share-btn').attr('href', ulr[8].get_url); // LINE Open Chat
                    $('.line-btn').attr('href', ulr[3].get_url); // LINE
                    $('.facebook-btn, .facebook-share-btn').attr('href', ulr[4].get_url); // Facebook
                    var youtube_url = 'https://www.youtube.com/@%E5%85%AC%E5%BC%8F%E6%9C%80%E5%BC%B7%E3%81%A7%E3%82%93%E3%81%A7%E3%82%93';
                    $('.youtube-btn').attr('href', youtube_url); // youtube

                    // 2025-7-22新增官充||活动按钮
                    var jump_url = 'https://pay.qcplay.co.jp/';
                    $.each(ulr, function(index, item) {
                        if (item.id === 28) {
                            jump_url = item.get_url;
                            $('.jump-btn').removeClass('pay-btn').addClass('activity-btn');
                            return false;
                        }
                    });
                    $('.jump-btn').attr('href', jump_url);

                    // 分享按钮
                    // $('.line-share-btn').attr('href', ulr[5].get_url); // line-share
                    // $('.facebook-share-btn').attr('href', ulr[6].get_url); // Facebook-share
                    // $('.twitter-share-btn').attr('href', ulr[7].get_url); // Twitter-share

                    // spec信息
                    $('.snail-spec .name').html(spec.name)
                    $('.snail-spec .type').html(spec.type)
                    $('.snail-spec .game_content').html(spec.game_content)
                    $('.snail-spec .server_time').html(spec.server_time)
                    $('.snail-spec .price').html(spec.price)
                    $('.snail-spec .download').html(spec.download)
                    $('.snail-spec .model').html(spec.model)
                    $('.snail-spec .rd').html(spec.rd)

                    // 综合
                    $.each(zonghe, function(index, values) {
                        var zongheHtml = `<li>
                            <a href="news-details-mobile.html?id=${values.id}">
                                <h2>${values.article_title}</h2>
                                <p>${values.article_excerpt}</p>
                                <span>${values.created_at}</span>
                            </a>
                        </li>`;;
                        $('.zonghe').append(zongheHtml);
                    });

                    // 活动新闻
                    $.each(activity, function(index, values) {
                        var activityHtml = `<li>
                            <a href="news-details-mobile.html?id=${values.id}">
                                <h2>${values.article_title}</h2>
                                <p>${values.article_excerpt}</p>
                                <span>${values.created_at}</span>
                            </a>
                        </li>`;
                        $('.activity').append(activityHtml);
                    });
                    $('.content-05 .banner').find('a').attr('href', 'news-details.html?id=' + activity[0].id);

                    // 漫画
                    if (cartoon.length > 4) {
                        cartoon = cartoon.splice(0, 3);
                        setTimeout(() => {
                            $('.cartoon').append('<li><a href="comic-sequel.html?id=13"><h2>+</h2></a></li>');
                        }, 0);
                    }
                    $.each(cartoon, function(index, values) {
                        var cartoonHtml = `<li>
                            <a href="news-details-mobile.html?id=${values.id}">
                                <h2>${values.article_title}</h2>
                            </a>
                        </li>`;
                        $('.cartoon').append(cartoonHtml);
                    });
                    // 新米编
                    $.each(beginner_guide, function(index, values) {
                        var beginner_guide = `<li>
                          <a href="introduction-details-mobile.html?id=${values.id}">
                              <h2>【${values.article_title}】</h2>
                              <p>作者：${values.origin}</p>
                          </a>
                      </li>`;
                        $('.beginner-guide').append(beginner_guide);
                    });

                    // 中级者编
                    $.each(intermediate, function(index, values) {
                        var intermediate = `<li>
                          <a href="introduction-details-mobile.html?id=${values.id}">
                              <h2>【${values.article_title}】</h2>
                              <p>作者：${values.origin}</p>
                          </a>
                      </li>`;
                        $('.intermediate').append(intermediate);
                    });
                    // // 攻略全部信息-首页
                    // $.each(introduction_index, function(index, values) {
                    //     var introduction_index = `<li>
                    //         <a href="introduction-details-mobile.html?id=${values.id}">
                    //             <h2>【${values.article_title}】</h2>
                    //             <p>作者：${values.origin}</p>
                    //         </a>
                    //     </li>`;
                    //     $('.introduction-index').append(introduction_index);
                    // });

                    // // 新手指南
                    // $.each(beginner_guide, function(index, values) {
                    //     var beginner_guide = `<li>
                    //         <a href="introduction-details-mobile.html?id=${values.id}">
                    //             <h2>【${values.article_title}】</h2>
                    //             <p>作者：${values.origin}</p>
                    //         </a>
                    //     </li>`;
                    //     $('.beginner-guide').append(beginner_guide);
                    // });

                    // // 形态介绍
                    // $.each(xingtai, function(index, values) {
                    //     var xingtai = `<li>
                    //         <a href="introduction-details-mobile.html?id=${values.id}">
                    //             <h2>【${values.article_title}】</h2>
                    //             <p>作者：${values.origin}</p>
                    //         </a>
                    //     </li>`;
                    //     $('.xingtai').append(xingtai);
                    // });

                    // 探索相关
                    $.each(explore, function(index, values) {
                        var explore = `<li>
                            <a href="introduction-details-mobile.html?id=${values.id}">
                                <h2>【${values.article_title}】</h2>
                                <p>作者：${values.origin}</p>
                            </a>
                        </li>`;
                        $('.explore').append(explore);
                    });

                    $.each(video, function(index, values) {
                        if (index == 2) return // 删除第一个视频
                        var videoHtml = `<div class="swiper-slide" data="${values.video_link}"><a href="javascript:;"><img src="${values.move_url}"></a></div>`;
                        $('.swiper-container-video .slideTxtBox-box').append(videoHtml);
                    });
                    _this.indextabVideo();
                    _this.Textlength(28, 25);
                } else {
                    layer.msg("サーバーに接続できません", { time: 2000 });
                }

            },
            error: function() {
                layer.msg("サーバーに接続できません", { time: 2000 });
            },
            complete: function() {
                layer.close(index);
            }
        })
    },
    // 首页轮播
    indexSwiper: function() {
        function pageSwiper() {
            var mySwiper = new Swiper('.swiper-container', {
                pagination: '.swiper-pagination',
                direction: 'vertical',
                slidesPerView: 'auto',
                paginationClickable: true,
                spaceBetween: 0,
                mousewheelControl: true,
                resistanceRatio: 0,
                parallax: true,
                onInit: function(swiper) {
                    swiperAnimate(swiper);
                },
                onSlideChangeEnd: function(swiper) {
                    swiperAnimate(swiper);
                    swiper.activeIndex >= 7 ? $('.rocket').fadeIn() : $('.rocket').fadeOut();
                },
                onTouchEnd: function(swiper) {
                    swiperAnimate(swiper);
                },
            });
            $('body').on('click', '.rocket', function(event) {
                var _this = $(this);
                _this.addClass('rocket-ani')
                mySwiper.slideTo(0, 1000, true);
                setTimeout(function() { _this.fadeOut() }, 1000);
                setTimeout(function() { _this.removeClass('rocket-ani') }, 1500);
            });

            $('body').on('click', '.go-story', function(event) {
                var _data = $(this).attr('data');
                setTimeout(function() { mySwiper.slideTo(_data, 1000, true); }, 400);
            });
        }
        pageSwiper();

        function tabSwiperOne() {
            var swiper2 = new Swiper('.swiper-container2', {
                pagination: '.swiper-pagination',
                paginationClickable: true,
                spaceBetween: 50,
                speed: 300,
                onInit: function(swiper) {
                    function Ani(btn, page) {
                        $(btn).on('click', function() {
                            swiper2.slideTo(page - 1, 300, true);
                        });
                    };

                    function navLink() {
                        for (var i = 2; i >= 1; i--) {
                            Ani('.tit-li-0' + i + '', i);
                        };
                    }
                    navLink();
                },
                onSlideChangeEnd: function(swiper) {
                    $('.tit-ul li').removeClass('on')
                    $('.tit-li-0' + Number(swiper2.activeIndex + 1) + '').addClass('on');
                },
            });
        }
        tabSwiperOne();

        function tabSwiperTwo() {
            var swiper3 = new Swiper('.swiper-container3', {
                pagination: '.swiper-pagination',
                paginationClickable: true,
                spaceBetween: 50,
                speed: 300,
                onInit: function(swiper) {
                    function Ani(btn, page) {
                        $(btn).on('click', function() {
                            swiper3.slideTo(page - 1, 300, true);
                        });
                    };

                    function navLink() {
                        for (var i = 4; i >= 1; i--) {
                            Ani('.tit-li-0' + i + '', i);
                        };
                    }
                    navLink();
                },
                onSlideChangeEnd: function(swiper) {
                    $('.tit-ul li').removeClass('on')
                    $('.tit-li-0' + Number(swiper3.activeIndex + 1) + '').addClass('on');
                },
            });
        }
        tabSwiperTwo();

        function tabSwiperThree() {
            var swiper3 = new Swiper('.swiper-container4', {
                pagination: '.swiper-pagination',
                paginationClickable: true,
                spaceBetween: 50,
                speed: 300,
                onInit: function(swiper) {
                    function Ani(btn, page) {
                        $(btn).on('click', function() {
                            swiper3.slideTo(page - 1, 300, true);
                        });
                    };

                    function navLink() {
                        for (var i = 4; i >= 1; i--) {
                            Ani('.tit-li-0' + i + '', i);
                        };
                    }
                    navLink();
                },
                onSlideChangeEnd: function(swiper) {
                    $('.tit-ul li').removeClass('on')
                    $('.tit-li-0' + Number(swiper3.activeIndex + 1) + '').addClass('on');
                },
            });
        }
        tabSwiperThree();
    },
    indextabVideo: function() {
        setTimeout(function() {
            function tabVideo() {
                var mySwiperVideo = new Swiper('.swiper-container-video', {
                    loop: true,
                    pagination: '.swiper-pagination',
                    effect: 'coverflow',
                    grabCursor: true,
                    centeredSlides: true,
                    nextButton: '.swiper-button-next',
                    prevButton: '.swiper-button-prev',
                    slidesPerView: 'auto',
                    coverflow: {
                        rotate: 0, // 旋转的角度
                        stretch: 12.3, // 拉伸   图片间左右的间距和密集度
                        depth: 30, // 深度   切换图片间上下的间距和密集度
                        modifier: 10, // 修正值 该值越大前面的效果越明显
                    },
                });
            }
            tabVideo()
        }, 100)
    },
    // 内容字体长度超过40，标题字体长度超过25
    Textlength: function(x1, x2) {
        $('.slideTxtBox .bd p').each(function() {
            if ($(this).text().length > x1) {
                var str = $(this).text();
                $(this).text(str.substr(0, x1) + '...');
            }
        });
        $('.slideTxtBox .bd h2').each(function() {
            if ($(this).text().length > x2) {
                var str = $(this).text();
                $(this).text(str.substr(0, x2) + '...');
            }
        });
    },
    // 隐藏导航
    hiddenNav: function() {
        // 隐藏导航
        var change = true;
        $('.navBox').on('click', '.nav_more', function() {
            if (change == true) {
                $('.nav_more').addClass('change');
                $('.nav-popup').addClass('nav-popup-show');
                change = false;
            } else {
                $('.nav_more').removeClass('change');
                $('.nav-popup').removeClass('nav-popup-show');
                change = true;
            }
            $('.screen-popup').fadeOut();
            $('.bottom-nav li').removeClass('on');
        });

        $('body').on('click', '.go-story', function(event) {
            $('.nav_more').removeClass('change');
            $('.nav-popup').removeClass('nav-popup-show');
            change = true;
        });
    },
    // 获取当前hash的具体参数
    getQueryVariable: function(variable) {
        var query = window.location.href.split('?')[1];
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            if (pair[0] == variable) { return pair[1]; }
        }
        return (false);
    },
    // 最新、综合、活动跳转
    newsTabPage: function() {
        $('.all-list').on('click', 'li', function(event) {
            $(this).addClass('on').siblings('a').removeClass('on');
            var cate_id = $(this).attr('cate-id');
            window.location.href = window.location.href.split("?")[0] + '?cate_id=' + cate_id + '&page=1'
        });
    },
    // 新闻列表接口
    newsZxList: function(urls) {
        var cate_id, page, current, index;
        current = window.location.href.split("?")[0];
        cate_id = window.location.href.split("?")[1].split("&page=")[0].split("cate_id=")[1];
        page = window.location.href.split("&page=")[1];
        index = layer.load(2, { shade: [0.1, '#fff'] });
        $('.li-tab-0' + cate_id + '').addClass('on').siblings().removeClass('on');

        function newsAjax(urls) {

            $.ajax({
                url: urls,
                type: "GET",
                data: {
                    // cate_id 最新-综合-活动
                    // page    1...
                    cate_id: cate_id,
                    page: page,
                },
                xhrFields: {
                    withCredentials: true
                },
                success: function(json) {
                    if (json.code == 200) {
                        var current_page = json.data.articleList.current_page; // 当前页数
                        var last_page = json.data.articleList.last_page; // 总共页数
                        var next_page_url = json.data.articleList.next_page_url; // 后一页
                        var _data = json.data.articleList.data;

                        if (_data.length == 0) {
                            $('.list-wrap').addClass('list-null');
                        } else {
                            $('.list-wrap').removeClass('list-null');
                            // 渲染列表
                            $.each(json.data.articleList.data, function(index, values) {
                                var dtHtml = `<li>
                                        <a title="${values.article_title}" href="news-details-mobile.html?id=${values.id}">
                                            <h2>${values.article_title}</h2>
                                            <p>${values.article_excerpt}</p>
                                            <span>${values.created_at}</span>
                                        </a>
                                    </li>`;
                                $('.list-wrap ul').append(dtHtml);
                            });
                            $('.current_page').html(current_page); // 当前页数
                            $('.last_page').html(last_page); // 总共页数
                            if (next_page_url === null) { // 下一页
                                $('.more-btn').remove();
                            } else {
                                page++
                                $('.more-btn a').attr('data', next_page_url.split("jpweb")[1]);
                            }
                        }
                    } else {
                        layer.msg("サーバーに接続できません", { time: 2000 });
                    }

                },
                error: function() {
                    layer.msg("サーバーに接続できません", { time: 2000 });
                },
                complete: function() {
                    layer.close(index);
                }
            })
        }
        newsAjax(urls);
        $('.more-btn').on('click', 'a', function(event) {
            var _this = $(this);
            if (_this.attr('data') == '') {
                layer.msg("もうない", { time: 2000 });
            } else {
                index = layer.load(2, { shade: [0.1, '#fff'] });
                setTimeout(function() {
                    urls = api + _this.attr('data');
                    newsAjax(urls);
                }, 100)
            }
        });
        for (var i = $('.link-box-02 div a').length; i >= 1; i--) {
            if (cate_id == i) $('.link-box-02 div a:nth-child(' + i + ')').addClass('on');
        };
    },
    // 新闻详情
    newsInfo: function() {
        var id = window.location.href.split('?id=')[1];
        var index = layer.load(2, { shade: [0.1, '#fff'] });
        $.ajax({
            url: api + "/article/" + id + "",
            type: "GET",
            xhrFields: {
                withCredentials: true
            },
            success: function(json) {

                if (json.code == 200) {
                    var newsTitle = json.data.list.article_title; // 标题
                    var detailsInfo = json.data.list.article_content; // 内容
                    var origin = json.data.list.origin; // 作者
                    var created_at = json.data.list.created_at; // 时间
                    $('.news-title, .current-title').html(newsTitle);
                    if (detailsInfo !== '') {
                        $('.details-info').append(detailsInfo);
                    } else {
                        // <iframe id="media-play" width="817" height="500" src="" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        $('.details-info').append('<iframe id="media-play" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen width="100%" height="100%" disablepictureinpicture="true" style="background-color:#000" src="' + json.data.list.video_link + '"></iframe>');
                    }

                    // 
                    $('.origin').html(origin);
                    $('.created_at').html(created_at);
                    // 翻页功能
                    obj.pageDown(json.data.last, json.data.next, 'id');

                    $('title').html(newsTitle + ' 最強でんでん - 株式会社QCPlay');
                    $('meta[name="keywords"]').attr('content', json.data.list.article_keywords);
                    $('meta[name="description"]').attr('content', json.data.list.article_excerpt);

                } else {
                    layer.msg("サーバーに接続できません", { time: 2000 });
                }

            },
            error: function() {
                layer.msg("サーバーに接続できません", { time: 2000 });
            },
            complete: function() {
                layer.close(index);
            }
        })
    },
    // 翻页功能
    pageDown: function(lastPage, nextPage, cite) {
        var href = window.location.href.split("?")[0] + '?' + cite + '='
        if (lastPage !== '') $('.prev-page').addClass('show').attr('href', href + lastPage.id).attr('title', lastPage.article_title);
        if (nextPage !== '') $('.next-page').addClass('show').attr('href', href + nextPage.id).attr('title', nextPage.article_title);
    },
    // 视频切换
    videoSwitch: function() {
        $('.all-list').on('click', 'li', function(event) {
            $(this).addClass('on').siblings('a').removeClass('on');
            var cate_id = $(this).attr('cate-id');
            window.location.href = window.location.href.split("?")[0] + '?id=' + cate_id
        });
    },
    // 新闻列表接口
    newsIntrList: function(urls) {
        var cate_id, page, current, index;
        current = window.location.href.split("?")[0];
        cate_id = window.location.href.split("?")[1].split("&page=")[0].split("cate_id=")[1];
        page = window.location.href.split("&page=")[1];

        index = layer.load(2, { shade: [0.1, '#fff'] });
        $('.li-tab-0' + cate_id + '').addClass('on').siblings().removeClass('on');

        function newsAjax(urls) {
            $.ajax({
                url: api + "/new/list",
                type: "GET",
                data: {
                    // cate_id 最新-综合-活动
                    // page    1...
                    cate_id: cate_id,
                    page: page,
                },
                xhrFields: {
                    withCredentials: true
                },
                success: function(json) {
                    if (json.code == 200) {
                        var current_page = json.data.current_page; // 当前页数
                        var last_page = json.data.last_page; // 总共页数
                        var next_page_url = json.data.next_page_url; // 后一页
                        var _data = json.data.data;
                        if (_data.length == 0) {
                            $('.list-wrap').addClass('list-null');
                        } else {
                            $('.list-wrap').removeClass('list-null');
                            // 渲染列表
                            $.each(_data, function(index, values) {
                                var dtHtml = `<li>
                                        <a title="${values.article_title}" href="introduction-details-mobile.html?id=${values.id}">
                                            <h2>${values.article_title}</h2>
                                            <span>${values.created_at}</span>
                                        </a>
                                    </li>`;
                                $('.list-wrap ul').append(dtHtml);
                            });
                            $('.current_page').html(current_page); // 当前页数
                            $('.last_page').html(last_page); // 总共页数
                            if (next_page_url === null) { // 下一页
                                $('.more-btn a').attr('data', '').html('もうない'); // 没有最后一页
                            } else {
                                page++
                                $('.more-btn a').attr('data', next_page_url);
                            }
                        }
                    } else {
                        layer.msg("サーバーに接続できません", { time: 2000 });
                    }

                },
                error: function() {
                    layer.msg("サーバーに接続できません", { time: 2000 });
                },
                complete: function() {
                    layer.close(index);
                }
            })
        }
        newsAjax(urls);
        $('.more-btn').on('click', 'a', function(event) {
            if ($(this).attr('data') == '') {
                layer.msg("もうない", { time: 2000 });
            } else {
                urls = $(this).attr('data');
                newsAjax(urls);
            }
        });

        // 导航变色
        if (cate_id == 1) $('.link-box-03 div a:nth-child(1)').addClass('on');
        if (cate_id == 9) $('.link-box-03 div a:nth-child(2)').addClass('on');
        if (cate_id == 19) $('.link-box-03 div a:nth-child(4)').addClass('on');
    },
    // 获取视频中心视频
    videoCenterAjax: function() {
        var id = window.location.href.split("?id=")[1];
        var index = layer.load(2, { shade: [0.1, '#fff'] });
        $('.li-tab-0' + id + '').addClass('on').siblings().removeClass('on');

        // 全部视频
        $.ajax({
            url: api + "/article?cate_id=" + id + "&limit=0",
            type: "GET",
            xhrFields: {
                withCredentials: true
            },
            success: function(json) {
                if (json.code == 200) {
                    // 渲染视频数量
                    $.each(json.data.articleList2, function(index, values) {
                        var dtHtml = '<li><a style="text-indent: -12.15rem;" href="video-details.html?id=' + values.id + '">' + values.article_title + '</a></li>';
                        $('.cartoon-list ul').append(dtHtml);
                    });
                    $('.cartoon-list ul li:nth-child(1)').html();
                    var info = $('.cartoon-list ul li:nth-child(1) a').html()
                    var href = $('.cartoon-list ul li:nth-child(1) a').attr('href');
                    $('.synopsis .start').attr('href', href).find('span').html(info);
                    $('.s-title span').html('(第' + parseInt(json.data.articleList2.length) + '話まで連載)');

                } else {
                    layer.msg("サーバーに接続できません", { time: 2000 });
                }

            },
            error: function() {
                layer.msg("サーバーに接続できません", { time: 2000 });
            },
            complete: function() {
                layer.close(index);
            }
        })

        for (var i = $('.link-box-04 div a').length; i >= 1; i--) {
            if (id == 1 + '' + i + '') $('.link-box-04 div a:nth-child(' + i + ')').addClass('on');
        };
    },
    // 获取详细视频
    videoDetailsAjax: function() {
        var id = window.location.href.split("?id=")[1];
        var index = layer.load(2, { shade: [0.1, '#fff'] });
        $.ajax({
            url: api + "/article/" + id + "",
            type: "GET",
            xhrFields: {
                withCredentials: true
            },
            success: function(json) {

                if (json.code == 200) {
                    var newsTitle = json.data.list.article_title; // 标题
                    var detailsInfo = json.data.list.article_content; // 内容
                    var origin = json.data.list.origin; // 作者
                    var created_at = json.data.list.created_at; // 时间
                    var video_link = json.data.list.video_link; // 视频
                    $('.news-title, .current-title').html(newsTitle);
                    $('.details-info').append(detailsInfo);
                    $('.origin').html(origin);
                    $('.created_at').html(created_at);
                    $('.details-info iframe').attr('src', video_link);
                    // 翻页功能
                    obj.pageDown(json.data.last, json.data.next, 'id');

                    $('title').html(newsTitle + ' 最強でんでん - 株式会社QCPlay');
                    $('meta[name="keywords"]').attr('content', json.data.list.article_keywords);
                    $('meta[name="description"]').attr('content', json.data.list.article_excerpt);
                } else {
                    layer.msg("サーバーに接続できません", { time: 2000 });
                }

            },
            error: function() {
                layer.msg("サーバーに接続できません", { time: 2000 });
            },
            complete: function() {
                layer.close(index);
            }
        })
    },
    // 同人专区-作品详情
    drawingInfo: function() {
        var article = window.location.href.split("?article=")[1];
        var index = layer.load(2, { shade: [0.1, '#fff'] });
        $.ajax({
            url: api + "/article/" + article + "",
            type: "GET",
            xhrFields: {
                withCredentials: true
            },
            success: function(json) {
                if (json.code == 200) {
                    var newsTitle = json.data.list.article_title; // 标题
                    var detailsInfo = json.data.list.article_content; // 内容
                    var origin = json.data.list.origin; // 作者
                    var created_at = json.data.list.created_at; // 时间
                    var like_num = json.data.list.like_num; // 点赞
                    var video_link = json.data.list.video_link; // 视频

                    // 如果内容是空则为视频-否则默认新闻输出
                    if (detailsInfo == '') {
                        $('.details-info div').append('<video controls="controls" controlslist="nodownload" src="' + video_link + '" width="100%" height="100%" disablepictureinpicture="true" autoplay="autoplay" style="background-color: black;"></video>');
                    }
                    // 图片或者视频输出
                    $('.details-info div').append(detailsInfo);
                    $('.details-info').fadeIn();
                    $('.news-title, .current-title').html(newsTitle);
                    $('.origin').html(origin);
                    $('.created_at').html(created_at);
                    $('.btnVote').html(like_num);
                    // 翻页功能
                    obj.pageDown(json.data.last, json.data.next, 'article');
                } else {
                    layer.msg("サーバーに接続できません", { time: 2000 });
                }

            },
            error: function() {
                layer.msg("サーバーに接続できません", { time: 2000 });
            },
            complete: function() {
                layer.close(index);
            }
        })

        // 点赞
        $('.btnVote').click(function(event) {
            $.ajax({
                url: api + "/article/?id=" + article + "",
                type: "POST",
                xhrFields: {
                    withCredentials: true
                },
                success: function(json) {
                    if (json.code == 200) {
                        $('.alert_box').fadeIn();
                        var number = Number($('.btnVote').html()) + 1;
                        $('.btnVote').html(number)
                    } else {
                        layer.msg("サーバーに接続できません", { time: 2000 });
                    }

                },
                error: function() {
                    layer.msg("サーバーに接続できません", { time: 2000 });
                },
                complete: function() {
                    layer.close(index);
                }
            })
        });

        // 关闭点赞提示框
        $('.alert_box .alertClose, .alert_box .btnsConfirm').click(function(event) {
            $('.alert_box').fadeOut();
        });
    },
    // wiki轮播
    wikiSwiper: function() {
        var swiper2 = new Swiper('.swiper-container2', {
            pagination: '.swiper-pagination',
            paginationClickable: true,
            spaceBetween: 50,
            speed: 300,
        });
    },
    wikiIndexAjax: function() {
        var index = layer.load(2, { shade: [0.1, '#fff'] });
        var _this = this;
        $.ajax({
            url: api + "/getdata",
            type: "GET",
            xhrFields: {
                withCredentials: true
            },
            success: function(json) {
                if (json.code == 200) {
                    var banner = json.data.articleList.banner; // 地图探索
                    var ditu = json.data.articleList.ditu; // 地图探索
                    var hot = json.data.articleList.hot; // 热门
                    var xinshou = json.data.articleList.xinshou.data; // 新手
                    var xingtai = json.data.articleList.xingtai; // 形态
                    var index = json.data.articleList.index; // 热门

                    // // 渲染-地图探索
                    $.each(banner, function(index, values) {
                        var addHtml = `<div class="swiper-slide">
                            <a href="${values.url}">
                                <img src="${values.mobile_background}">
                            </a>
                        </div>`;
                        $('.swiper-container2 .swiper-wrapper').append(addHtml);
                    });
                    _this.wikiSwiper();
                    $('.swiper-container2 .swiper-slide:nth-child(1)').find('a').attr('href', 'introduction-list-mobile.html?cate_id=9&page=1');
                    $('.swiper-container2 .swiper-slide:nth-child(2)').find('a').attr('href', 'wiki-precious-mobile.html');
                    $('.swiper-container2 .swiper-slide:nth-child(3)').find('a').attr('href', 'introduction-list-mobile.html?cate_id=17&page=1');

                    // // 渲染-地图探索
                    $.each(ditu, function(index, values) {
                        var addHtml = `<li><a href="news-details-mobile.html?id=${values.id}"><img src="${values.thumbnail}"><span></span></a></li>`;
                        $('.map-exploration ul').prepend(addHtml);
                    });

                    $('.map-exploration li:nth-child(1)').find('span').html('高麗');
                    $('.map-exploration li:nth-child(2)').find('span').html('大和');
                    $('.map-exploration li:nth-child(3)').find('span').html('中華');
                    $('.map-exploration li:nth-child(4)').find('span').html('米国');
                    $('.map-exploration li:nth-child(5)').find('span').html('英伦');

                    // // 渲染-热门
                    $.each(hot, function(index, values) {
                        var addHtml = `<li><a href="news-details-mobile.html?id=${values.id}">${values.article_title}</a></li>`;
                        $('.hot-pages .list ul').append(addHtml);
                    });
                    // // 新手指南
                    for (var i = $('.novice-guide li').length - 1; i >= 0; i--) {
                        $('.novice-guide .li-0' + i + ' a').attr('href', 'news-details-mobile.html?id=' + xinshou[i].id + '');
                    };

                    // // 渲染-形态
                    $.each(xingtai, function(index, values) {
                        var addHtml = `<li><a href="news-details-mobile.html?id=${values.id}"><img src="${values.thumbnail}"><span>${values.cate_id}</span></a></li>`;
                        $('.form-intr ul').prepend(addHtml);
                    });

                    // 先固定写死
                    $('.form-intr ul li:nth-child(1)').find('span').html('ゾンビ');
                    $('.form-intr ul li:nth-child(2)').find('span').html('悪魔');
                    $('.form-intr ul li:nth-child(3)').find('span').html('天使');
                    $('.form-intr ul li:nth-child(4)').find('span').html('メカ');
                    $('.form-intr ul li:nth-child(5)').find('span').html('異形');
                    $('.form-intr ul li:nth-child(6)').find('span').html('ドラゴン');

                } else {
                    layer.msg("サーバーに接続できません", { time: 2000 });
                }
            },
            error: function() {
                layer.msg("サーバーに接続できません", { time: 2000 });
            },
            complete: function() {
                layer.close(index);
            }
        })
    },
    // 获取需要筛选的wiki参数
    getWikiData: function() {
        var index = layer.load(2, { shade: [0.1, '#fff'] });
        $.ajax({
            url: api + "/get_type",
            type: "GET",
            xhrFields: {
                withCredentials: true
            },
            success: function(json) {
                if (json.code == 200) {
                    // 渲染-wiki-光环技能的参数
                    $.each(json.data.data.halo_effect, function(index, values) {
                        var addHtml = `<li data="${values}">${values}</li>`;
                        $('.halo_effect').append(addHtml);
                    });

                    // 渲染-wiki-镶嵌技能的参数
                    $.each(json.data.data.mosaic_skill, function(index, values) {
                        var addHtml = `<li data="${values}">${values}</li>`;
                        $('.mosaic_skill').append(addHtml);
                    });
                    $('.halo_effect, .mosaic_skill').find('li:nth-child(1)').addClass('on').attr('data', '');
                } else {
                    layer.msg("サーバーに接続できません", { time: 2000 });
                }

            },
            error: function() {
                layer.msg("サーバーに接続できません", { time: 2000 });
            },
            complete: function() {
                layer.close(index);
            }
        })
    },
    wikibind: function() {
        $('.bottom-nav').on('click', 'li', function(event) {
            $(this).addClass('on').siblings().removeClass('on');
            $(this).attr('data');
            $('.screen-popup').fadeIn().find('.' + $(this).attr('data') + '').fadeIn().siblings('.screen-wrap').hide();
            $('.nav_more').removeClass('change');
            $('.nav-popup').removeClass('nav-popup-show');
            change = true;
        });
    },
    // 信息切换-关闭弹窗清除数据
    wikiTabInfo: function() {
        $('.info-box .tit').on('click', 'h4', function(event) {
            $(this).addClass('on').siblings().removeClass('on').parent('.tit').siblings('.con').children('div').eq($(this).index()).addClass('show').siblings().removeClass('show');
        });
    },
    // 贵重物品弹窗
    wikiPopup: function() {
        // 开启弹窗
        $('.goods-list-wrap').on('click', 'li', function(event) {
            $('.wiki-popup').fadeIn();
            var title = $(this).attr('titles'); // 标题
            var colour = $(this).attr('colour'); // 颜色
            var art = $(this).attr('art'); // 艺术
            var culture = $(this).attr('culture'); // 文化
            var describe = $(this).attr('describe'); // 简介
            var deviation = $(this).attr('deviation'); // 偏向
            var faith = $(this).attr('faith'); // 信仰
            var get_type = $(this).attr('get_type'); // 获取途径  
            var halo_effect = $(this).attr('halo_effect'); // 光环技能
            var id = $(this).attr('id'); // 图片id
            var mosaic_skill = $(this).attr('mosaic_skill'); // 镶嵌技能
            var popularity = $(this).attr('popularity'); // 人气
            var quality = $(this).attr('quality');
            var rarity = $(this).attr('rarity');
            var rarity_order = $(this).attr('rarity_order');
            var technology = $(this).attr('technology'); // 科技

            if (rarity == '无') rarity = '' // 无不输出

            $('.wiki-wrap h1').html(title); // 标题
            $('.wiki-wrap .span-pj').html(quality + rarity); // 颜色
            $('.wiki-wrap .span-px').html(deviation); // 偏向

            $('.wiki-wrap .pic-img img').attr('src', 'https://qcplay-platform.oss-cn-hangzhou.aliyuncs.com/qcgame-admin/snailValuables/' + id + '.png')
            $('.wiki-wrap .pic-img').addClass('pic-img-0' + colour + ''); // 框框颜色

            if (halo_effect == '') halo_effect = '暂无数据'
            if (mosaic_skill == '') mosaic_skill = '暂无数据'
            if (get_type == '') get_type = '暂无数据'
            if (describe == '') describe = '暂无数据'
            $('.wiki-wrap .p-01').html(halo_effect); // 光环技能
            $('.wiki-wrap .p-02').html(mosaic_skill); // 镶嵌技能
            $('.wiki-wrap .p-03').html(get_type); // 镶嵌技能
            $('.wiki-wrap .p-04').html(describe); // 简介

            $('.wiki-wrap .data-ul .li-01').html(popularity); // 人气
            $('.wiki-wrap .data-ul .li-02').html(art); // 艺术
            $('.wiki-wrap .data-ul .li-03').html(faith); // 信仰
            $('.wiki-wrap .data-ul .li-04').html(culture); // 文化
            $('.wiki-wrap .data-ul .li-05').html(technology); // 科技

            if (colour == 1) colour = '#f9ab61'
            if (colour == 2) colour = '#81c9d4'
            if (colour == 3) colour = '#9cbd56'
            if (colour == 4) colour = '#DCA8C7'
            myChart(popularity, art, faith, culture, technology, colour);
        });

        // 关闭弹窗
        $('.wiki-popup').on('click', '.close-btn', function(event) {
            $('.wiki-popup').fadeOut();
            setTimeout(function() {
                for (var i = 4; i >= 0; i--) $('.wiki-wrap .pic-img').removeClass('pic-img-0' + i + ''); // 框框颜色
                $('.wiki-wrap .pic-img img').attr('src', '');
                $('.wiki-wrap h1, .wiki-wrap h2 span').html(''); // 清空标题/颜色
                $('.wiki-wrap .con p').html(''); // 清空光环技能/镶嵌技能/镶嵌技能/简介
                $('.wiki-wrap .data-ul li').html(''); // 清空/人气/艺术/信仰/文化/科技
                $('.wiki-wrap .tit .h4-01').addClass('on').siblings().removeClass('on'); // tab恢复
                $('.wiki-wrap .con div:nth-child(1)').addClass('show').siblings().removeClass('show'); // tab恢复
            }, 300)
        });

        function myChart(popularity, art, faith, culture, technology, colour) {
            //指定图表的配置项和数据
            option = {
                tooltip: {},
                radar: {
                    center: ['50%', '60%'],
                    startAngle: 90,
                    name: {
                        formatter: '{value}',
                        textStyle: {
                            color: '#937f80',
                            fontSize: '8',
                            lineHeight: 8,
                            padding: [0, 0],
                        },
                        formatter: function(data, indicator) {
                            let data0 = data.substring(0, 2)
                            let data1 = data.substring(2)
                            if (data1 == maxData) indicator.nameTextStyle.color = colour
                            return data0 + '\n' + data1
                        },
                    },
                    // 指示器名称和指示器轴的距离。[ default: 5 ]
                    nameGap: 5,
                    // 雷达图圈数设置
                    splitNumber: 2,
                    // 设置雷达图中间射线的颜色
                    axisLine: {
                        lineStyle: {
                            width: 2,
                            color: '#ae988b',
                        },
                    },
                    splitArea: {
                        show: true,
                        areaStyle: {
                            color: '#EDDCC4', // 图表背景的颜色
                        },
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            width: 2,
                            color: '#ac998b', // 设置网格的颜色
                        },
                    },
                    indicator: [
                        { name: '人气' + popularity, max: 120 },
                        { name: '科技' + technology, max: 120 },
                        { name: '文化' + culture, max: 120 },
                        { name: '信仰' + faith, max: 120 },
                        { name: '艺术' + art, max: 120 },
                    ],
                    radius: 41
                },
                series: [{
                    type: 'radar',
                    itemStyle: { // 折线拐点标志的样式。
                        normal: { // 普通状态时的样式
                            lineStyle: {
                                width: 2,
                                color: colour,
                            },
                        },
                    },
                    data: [{
                        value: [popularity, technology, culture, faith, art],
                        itemStyle: { // 单个拐点标志的样式设置。
                            normal: {
                                color: 'rgba(60,135,213,.3)',
                                opacity: 0.2,
                                // 拐点的描边颜色。[ default: '#000' ]
                                borderWidth: 1,
                                // 拐点的描边宽度，默认不描边。[ default: 0 ]
                            }
                        },
                        areaStyle: {
                            normal: {
                                color: colour // 选择区域颜色
                            }
                        }

                    }, ],
                }]
            };
            var maxData = Math.max.apply(this, option.series[0].data[0].value)
                //获取dom容器
            var myChart = echarts.init(document.getElementById('chartmain'));
            // 使用刚指定的配置项和数据显示图表。
            myChart.setOption(option);
        }
    },
    // wiki-贵重物品-搜索
    wikiearch: function() {
        var _this = this;
        $('.search-btn').on('click', function(event) {
            var searchIpu = $('.search-input').val()
            if (searchIpu == '') {
                layer.msg("検索するIDをを入力してください", { time: 2000 });
                return
            }
            var index = layer.load(2, { shade: [0.1, '#fff'] });
            $.ajax({
                url: api + "/goods",
                type: "GET",
                data: {
                    title: searchIpu
                },
                xhrFields: {
                    withCredentials: true
                },
                success: function(json) {
                    if (json.code == 200) {
                        var next_page_url = json.data.data.next_page_url; // 下一页的数据
                        // 如果下页有参数则显示更多按钮
                        next_page_url !== null ? $('.more-wrap').fadeIn().attr('data', next_page_url) : $('.more-wrap').hide();

                        $('.search-input').val('') // 搜索完成后搜索栏目清空
                            // 清除信息
                        var gradeSet = resetSet('.grade');
                        var dimensionSet = resetSet('.dimension');
                        var halo_effectSet = resetSet('.halo_effect');
                        var mosaic_skillSet = resetSet('.mosaic_skill');
                        var grade_arraySet = resetSet('.grade_array');

                        function resetSet(li) {
                            $(li).find('li').removeClass('on');
                        }

                        $('.goods-list-wrap ul').find('li').remove();
                        if (json.data.data.data == '') {
                            layer.msg("お探しの貴重品が見つかりません", { time: 2000 });
                            $('.tips-wrap').fadeIn();
                        } else {
                            $.each(json.data.data.data, function(index, values) {
                                var addHtml = `<li class="li-color-0${values.colour}" 
                                titles="${values.title}"
                                colour="${values.colour}" 
                                art="${values.art}" 
                                culture="${values.culture}" 
                                describe="${values.describe}" 
                                deviation="${values.deviation}" 
                                faith="${values.faith}" 
                                get_type="${values.get_type}" 
                                halo_effect="${values.halo_effect}" 
                                id="${values.id}" 
                                mosaic_skill="${values.mosaic_skill}" 
                                popularity="${values.popularity}" 
                                quality="${values.quality}" 
                                rarity="${values.rarity}" 
                                rarity_order="${values.rarity_order}" 
                                technology="${values.technology}">
                                    <div>
                                        <img src="https://qcplay-platform.oss-cn-hangzhou.aliyuncs.com/qcgame-admin/snailValuables/${values.id}.png">
                                    </div>
                                    <span>${values.title}</span>
                                </li>`;
                                $('.goods-list-wrap ul').append(addHtml);
                            });
                            $('.tips-wrap').hide();
                        }
                    }
                },
                error: function() {
                    layer.msg("サーバーに接続できません", { time: 2000 });
                },
                complete: function() {
                    layer.close(index);
                }
            })

        });
    },
    // 获取漫画续集信息
    comicSequelAjax: function() {
        var id = window.location.href.split("?id=")[1];
        var index = layer.load(2, { shade: [0.1, '#fff'] });
        $.ajax({
            url: api + "/article?cate_id=" + id + "&limit=0",
            type: "GET",
            xhrFields: {
                withCredentials: true
            },
            success: function(json) {
                if (json.code == 200) {
                    // 渲染漫画列表数量

                    $.each(json.data.articleList, function(index, values) {
                        var dtHtml = '<li><a href="news-details.html?id=' + values.id + '">' + values.article_title + '</a></li>';
                        $('.cartoon-list ul').append(dtHtml);
                    });
                    $('.cartoon-list ul li:nth-child(1)').html();
                    var info = $('.cartoon-list ul li:nth-child(1) a').html()
                    var href = $('.cartoon-list ul li:nth-child(1) a').attr('href');
                    $('.synopsis .start').attr('href', href).find('span').html(info);
                    // $('.s-title span').html('全'+parseInt(json.data.articleList.length)+'話');

                } else {
                    layer.msg("サーバーに接続できません", { time: 2000 });
                }

            },
            error: function() {
                layer.msg("サーバーに接続できません", { time: 2000 });
            },
            complete: function() {
                layer.close(index);
            }
        })
    },
    // wiki-贵重物品-筛选
    filtering: function() {
        rarity = ''; // 品阶
        deviation = ''; // 五围
        halo_effect = ''; // 光环技能
        mosaic_skill = ''; // 镶嵌技能
        column = ''; // 筛选参数1
        order = ''; // 筛选参数2
        page = ''; // 第几页
        url = api + "/goods"; // 需要请求的地址

        // 第一次进入时候请求一次
        function wikiDataAjax(url) {
            $('.loading-wrap').fadeIn();
            $.ajax({
                url: url,
                type: "GET",
                data: {
                    rarity: rarity,
                    deviation: deviation,
                    halo_effect: halo_effect,
                    mosaic_skill: mosaic_skill,
                    column: column,
                    order: order,
                    page: page
                },
                xhrFields: {
                    withCredentials: true
                },
                success: function(json) {
                    if (json.code == 200) {
                        var next_page_url = json.data.data.next_page_url; // 下一页的数据
                        // 渲染-所有贵重物品
                        // 橙色-1
                        // 蓝色-2
                        // 绿色-3
                        // 紫色-4
                        if (json.data.data.data.length !== 0) {
                            $.each(json.data.data.data, function(index, values) {
                                var addHtml = `<li class="li-color-0${values.colour}" 
                                titles="${values.title}"
                                colour="${values.colour}" 
                                art="${values.art}" 
                                culture="${values.culture}" 
                                describe="${values.describe}" 
                                deviation="${values.deviation}" 
                                faith="${values.faith}" 
                                get_type="${values.get_type}" 
                                halo_effect="${values.halo_effect}" 
                                id="${values.id}" 
                                mosaic_skill="${values.mosaic_skill}" 
                                popularity="${values.popularity}" 
                                quality="${values.quality}" 
                                rarity="${values.rarity}" 
                                rarity_order="${values.rarity_order}" 
                                technology="${values.technology}">
                                    <div>
                                        <img src="https://qcplay-platform.oss-cn-hangzhou.aliyuncs.com/qcgame-admin/snailValuables/${values.id}.png">
                                    </div>
                                    <span>${values.title}</span>
                                </li>`;
                                $('.goods-list-wrap ul').append(addHtml);
                            });
                            // 如果下页有参数则显示更多按钮
                            next_page_url !== null ? $('.more-wrap').fadeIn().attr('data', next_page_url) : $('.more-wrap').hide();
                            $('.tips-wrap, .loading-wrap').hide();
                        } else {
                            layer.msg("お探しの貴重品が見つかりません", { time: 2000 });
                            $('.tips-wrap').fadeIn();
                        }
                        $('.loading-wrap').hide();
                    } else {
                        $('.loading-wrap').fadeIn().html('サーバーに接続できません');
                    }

                },
                error: function() {
                    $('.loading-wrap').fadeIn().html('サーバーに接続できません');
                },
                complete: function() {
                    // layer.close(index);
                }
            })
        }
        wikiDataAjax(url);

        // 点击选择按钮
        $('.screen-wrap').on('click', 'li', function(event) {
            page = 1; // 每次点击按钮的时候回到第一页
            var _this = $(this);
            _this.addClass('on').siblings().removeClass('on');
            getLiData(); // 获取条件数据
            $('.goods-list-wrap ul').find('li').remove(); // 先清除一次再渲染
            wikiDataAjax(url); // 选择条件数据后ajax请求            
        });

        // 关闭弹窗
        $('.screen-close').click(function(event) {
            $('.screen-popup').fadeOut();
            $('.bottom-nav li').removeClass('on');
        });


        // 点击更多查看下一页
        $('.more-wrap').click(function(event) {
            page = $(this).attr('data').split("?page=")[1];
            getLiData(); // 获取条件数据
            wikiDataAjax(url) // 选择条件数据后ajax请求
        });

        // 获取数据信息
        function getLiData() {
            rarity = $('.grade').find('.on').attr('data'); // 品阶
            deviation = $('.dimension').find('.on').attr('data'); // 五围
            halo_effect = $('.halo_effect').find('.on').attr('data'); // 光环技能
            mosaic_skill = $('.mosaic_skill').find('.on').attr('data'); // 镶嵌技能
            column = $('.grade_array').find('.on').attr('column'); // 筛选参数1
            order = $('.grade_array').find('.on').attr('order'); // 筛选参数2
        }

        // wiki-贵重物品-筛选-复位清除选项
        $('.reset-btn').click(function(event) {
            $('.goods-list-wrap ul').find('li').remove();
            $('.screen-wrap ul li:nth-child(1)').addClass('on').siblings().removeClass('on');
            rarity = ''; // 品阶
            deviation = ''; // 五围
            halo_effect = ''; // 光环技能
            mosaic_skill = ''; // 镶嵌技能
            column = ''; // 筛选参数1
            order = ''; // 筛选参数2
            page = ''; // 第几页
            url = api + "/goods"; // 需要请求的地址
            wikiDataAjax(url);

            $('.screen-popup').fadeOut();

            $('.bottom-nav li').removeClass('on');
        });
    },
    // 尾部分享
    footShare: function() {
        // 开启分享二维码弹窗
        $('.follow-btn').click(function(event) {
            $('.follow-popup').fadeIn();
        });

        // 关闭分享弹窗
        $('.close-bg').click(function(event) {
            $('.follow-popup, .share-popup').fadeOut();
        });

        // 开启分享链接弹窗
        $('.share-btn').click(function(event) {
            $('.share-popup').fadeIn();
        });
    },
    // 阻止默认页面弹起影响触摸位置
    preventInput: function() {
        $("input").blur(function() {
            setTimeout(function() {
                var scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
                window.scrollTo(0, Math.max(scrollHeight - 1, 0));
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
            }, 100);
        });
    },
    // 书柜辞典模块
    bookcaseBind: function() {
        var dictionaries_data = '';
        var sort_data = '';

        $('.bookcase-box').on('click', 'li', function(event) {
            var data_id = $(this).attr('data');
            sort_data = $(this).attr('sort');
            var index = layer.load(2, { shade: [0.1, '#fff'] });
            for (var i = 14; i >= 1; i--) {
                $('.popup-business-card').removeClass('card-' + i + '');
            };
            $.ajax({
                url: api + "/dictionary/list",
                // url: "https://tapi.qingcigame.com/jpweb/dictionary/list",
                type: "POST",
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    area_id: data_id,
                },
                success: function(json) {
                    if (json.code == 200) {
                        var _data = json.data.illustrate_list.data;
                        $('.card-box ul li').remove();
                        $('.popup-business-card').fadeIn().addClass('card-' + sort_data + '');
                        $.each(_data, function(index, values) {
                            var bookcaseHtml = '<li>' +
                                '<span class="span-1">' + values.name + '</span>' +
                                '<span class="span-2">' + values.pseudonym + '</span>' +
                                '<span class="span-3">' + values.introduce + '</span>' +
                                '</li>';
                            $('.card-box ul').append(bookcaseHtml);
                        });
                        return
                    }
                    layer.msg(json.message, { time: 2000 });
                },
                error: function() {
                    layer.msg("サーバーに接続できません", { time: 2000 });
                },
                complete: function() {
                    layer.close(index);
                }
            })
        });


        $('.dictionaries').click(function(event) {
            for (var i = 2; i >= 1; i--) { $('.bookcase-box-' + i + ' li').remove() };
            var index = layer.load(2, { shade: [0.1, '#fff'] });
            if (dictionaries_data == '') {
                $.ajax({
                    url: api + "/area/list",
                    // url: "https://tapi.qingcigame.com/jpweb/area/list",
                    type: "GET",
                    xhrFields: {
                        withCredentials: true
                    },
                    success: function(json) {
                        if (json.code == 200) {
                            dictionaries_data = json;
                            $('.bookcase-wrap').fadeIn();
                            if (json.data.area_list[1] !== undefined) {
                                $.each(json.data.area_list[1], function(index, values) {
                                    var bookcaseHtml = '<li class="ani-btn" sort="' + values.sort + '" data="' + values.id + '">' +
                                        '<img src="' + values.area_image + '">' +
                                        '</li>';
                                    $('.bookcase-box-1').append(bookcaseHtml);
                                });
                            }
                            if (json.data.area_list[2] !== undefined) {
                                $.each(json.data.area_list[2], function(index, values) {
                                    var bookcaseHtml = '<li class="ani-btn" sort="' + values.sort + '" data="' + values.id + '">' +
                                        '<img src="' + values.area_image + '">' +
                                        '</li>';
                                    $('.bookcase-box-2').append(bookcaseHtml);
                                });
                            }
                            return
                        }
                        layer.msg(json.message, { time: 2000 });
                    },
                    error: function() {
                        layer.msg("サーバーに接続できません", { time: 2000 });
                    },
                    complete: function() {
                        layer.close(index);
                    }
                })
            } else {
                for (var i = 14; i >= 1; i--) {
                    $('.popup-business-card').removeClass('card-' + i + '');
                };
                $('.bookcase-wrap').fadeIn();
                if (dictionaries_data.data.area_list[1] !== undefined) {
                    $.each(dictionaries_data.data.area_list[1], function(index, values) {
                        var bookcaseHtml = '<li class="ani-btn" sort="' + values.sort + '" data="' + values.id + '">' +
                            '<img src="' + values.area_image + '">' +
                            '</li>';
                        $('.bookcase-box-1').append(bookcaseHtml);
                    });
                }
                if (dictionaries_data.data.area_list[2] !== undefined) {
                    $.each(dictionaries_data.data.area_list[2], function(index, values) {
                        var bookcaseHtml = '<li class="ani-btn" sort="' + values.sort + '" data="' + values.id + '">' +
                            '<img src="' + values.area_image + '">' +
                            '</li>';
                        $('.bookcase-box-2').append(bookcaseHtml);
                    });
                }
                layer.close(index);
            }
        });

        $('.close-bg').click(function(event) {
            $('.bookcase-wrap').fadeOut();
        });

        $('.egg-btn').click(function(event) {
            $('.egg-wrap').fadeIn();
        });

        $('.egg-wrap .close-bg , .egg-wrap .confirm-btn').click(function(event) {
            $('.egg-wrap').fadeOut();
        });

        $('.popup-business-card').click(function(event) {
            $(this).fadeOut();
        });
    },
    // 复制相关方法
    clipboard: function() {
        var clipboard = new Clipboard('.copy-btn');
        clipboard.on('success', function(e) {
            layer.msg('コピー成功!', { time: 2000 });
            e.clearSelection();
        });

        clipboard.on('error', function(e) {
            console.error('Action:', e.action);
            console.error('Trigger:', e.trigger);
        });
    },
    pageShow: function() {
        $('.page').addClass('pageShow');
    },
    share: function() {
        $.ajax({
            url: api + "/wechat/jssdk",
            type: "POST",
            data: {
                uri: window.location.href,
            },
            success: function(json) {
                if (json.code == 200) {
                    var ua = navigator.userAgent.toLowerCase();
                    if (ua.match(/MicroMessenger/i) == "micromessenger") {
                        wx.config(json.data);
                        wx.ready(function() {
                            wx.updateAppMessageShareData({
                                title: '最强蜗牛', // 分享标题
                                desc: '大家都爱玩的沙雕手游', // 分享描述
                                link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                                imgUrl: 'https://static.qcplay.com/common/snail_icon.png', // 分享图标
                                success: function() {}
                            })

                            wx.updateTimelineShareData({
                                title: '最强蜗牛-大家都爱玩的沙雕手游', // 分享标题
                                link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                                imgUrl: 'https://static.qcplay.com/common/snail_icon.png', // 分享图标
                                success: function() {
                                    // 设置成功
                                }
                            })
                        });
                        return;
                    } else {
                        try {
                            setShareInfo({
                                title: '最强蜗牛', // 分享标题
                                summary: '大家都爱玩的沙雕手游', // 分享内容
                                pic: 'https://static.qcplay.com/common/snail_icon.png', // 分享图片
                                url: window.location.href, // 分享链接
                                // 微信权限验证配置信息，若不在微信传播，可忽略
                                WXconfig: {
                                    swapTitleInWX: true, // 是否标题内容互换（仅朋友圈，因朋友圈内只显示标题）
                                    appId: json.data.appId, // 公众号的唯一标识
                                    timestamp: json.data.timestamp, // 生成签名的时间戳
                                    nonceStr: json.data.nonceStr, // 生成签名的随机串
                                    signature: json.data.signature // 签名
                                }
                            });
                        } catch (err) {}
                    }
                }
            }
        })
    },
    twitterShare: function() {
        // 插入推特推广
        $('.twitter-box').append('<a class="twitter-timeline" data-lang="ja" href="https://twitter.com/supersnail_jp">Tweets by MARVELOUS_SNAIL</a> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>');

        window.twttr = (function(d, s, id) {
            var js, fjs = d.getElementsByTagName(s)[0],
                t = window.twttr || {};
            if (d.getElementById(id)) return t;
            js = d.createElement(s);
            js.id = id;
            js.src = "https://platform.twitter.com/widgets.js";
            fjs.parentNode.insertBefore(js, fjs);

            t._e = [];
            t.ready = function(f) {
                t._e.push(f);
            };
            return t;
            var _iframe = document.createElement('iframe').contentWindow.document.body.find('a') //get iframe下的id
            _iframe.style.opacity = 0; //修改样式
        }(document, "script", "twitter-wjs"));
    },
    setInterval: function() {
        // 开始"信号干扰"和恢复时间（均为日本时间 UTC+9）
        const startTime = new Date("2025-06-05T23:00:00+08:00"); //三周年
        const changeTime = new Date("2025-06-08T11:00:00+08:00"); //信号干扰开始时间
        const restoreTime = new Date("2025-06-25T11:00:00+08:00"); //信号干扰结束时间
        const crimeStarTime = new Date("2025-06-27T11:00:00+08:00"); //罪状报告开始时间
        const crimeEndTime = new Date("2025-07-18T11:00:00+08:00"); //罪状报告结束时间
        const now = new Date();

        // 初始资源
        let icon = "/images/pc/wn-c2f62d9f03.ico";
        let preloading_bg = "/images/mobile/index_content_bg_01-54bae98f00.png";

        // 三周年
        if (now >= startTime && now < changeTime) {
            icon = "https://download4.qcplay.com/qcgame-api/a8Ecx9plbvpfrwmeP266NVohFWt8S9NUGaZWOXhu.png";
            preloading_bg = "/images/mobile/3rd/index_bg-f11bae9feb.png"

            $('.index').addClass('index-3rd');
        }

        // 信号干扰
        if (now >= changeTime && now < restoreTime) {
            icon = "https://download4.qcplay.com/qcgame-api/4PGBsJsrRvSsNgMxhzAR35UWh8ZaXW85G7mZ4prV.png";
            preloading_bg = "/images/mobile/3rd/index_bg_2-29e0a930e5.png"

            $('.index').addClass('index-3rd index-interfere');
            $('.egg-wrap').addClass('egg-interfere');
            $('.egg-box').addClass('egg-box-interfere');
        }

        // 三周年
        if (now >= restoreTime && now < crimeStarTime) {
            icon = "https://download4.qcplay.com/qcgame-api/a8Ecx9plbvpfrwmeP266NVohFWt8S9NUGaZWOXhu.png";
            preloading_bg = "/images/mobile/3rd/index_bg-f11bae9feb.png"

            $('.index').addClass('index-3rd');
        }

        // 罪状报告
        if (now >= crimeStarTime && now < crimeEndTime) {
            icon = "https://download4.qcplay.com/qcgame-api/Lr1hLvDcPDB7YVkfpRykKYKalb7cQtmh3wEScqXd.png";
            preloading_bg = "/images/mobile/3rd/index_bg-f11bae9feb.png"

            $('.index').addClass('index-3rd index-crime');
        }

        // 替换icon
        $('.preloading').css({
            'background-image': 'url(' + preloading_bg + ')',
            'background-size': '100% 100%',
            'background-position': 'top 100%'
        });
        $('#favicon').attr('href', icon);
    },
    // 阿里云埋点
    countNum: function(data) {
        setTimeout(() => {
            try {
                __bl.sum(data);
            } catch (e) {
                console.log(e)
            }
        }, 500);
    }
}